import * as React from 'react';

function SvgTick1(props: React.SVGProps<SVGSVGElement>) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18.71 15.896" {...props}>
            <path
                data-name="Path 11710"
                d="M16.7 5.759a6.461 6.461 0 01.384 2.189c0 3.984-3.649 7.226-8.135 7.226S.813 11.932.813 7.948 4.463.723 8.948.723a8.774 8.774 0 014.8 1.406l.621-.5A9.645 9.645 0 008.948 0C4.014 0 0 3.566 0 7.948S4.014 15.9 8.948 15.9 17.9 12.331 17.9 7.948a7.122 7.122 0 00-.565-2.776z"
                fill="#27742d"
            />
            <path
                data-name="Path 11711"
                d="M17.49 1.22L9.355 8.541 5.694 5.694l-1.22 1.22 4.881 4.881 9.355-9.762z"
                fill="#27742d"
            />
        </svg>
    );
}

export default SvgTick1;
